/** creatable Select에서 검색어와 정확히 일치하는 항목이 없으면 검색어를 생성 항목(created: true)으로 목록 뒤에 노출한다. */
export function applyCreatableItem(items: any[], filterText: string, creatable: boolean, itemId: string, label: string): any[] {
    if (!creatable || !filterText) return items;

    const trimmedFilterText = filterText.trim();
    if (!trimmedFilterText) return items;

    const normalizedFilterText = trimmedFilterText.toLowerCase();
    const hasExactMatch = items.some(item => String(item?.[label] ?? '').trim().toLowerCase() === normalizedFilterText);
    if (hasExactMatch) return items;

    return [...items, { [itemId]: trimmedFilterText, [label]: trimmedFilterText, label: trimmedFilterText, created: true }];
}

export default function filter({ loadOptions, filterText, items, multiple, value, itemId, groupBy, filterSelectedItems, itemFilter, convertStringItemsToObjects, filterGroupedItems, label }) {
    if (items && loadOptions) return items;
    if (!items) return [];

    if (items && items.length > 0 && typeof items[0] !== 'object') {
        items = convertStringItemsToObjects(items);
    }

    let filterResults = items.filter(item => {
        let matchesFilter = itemFilter(item[label], filterText, item);
        if (matchesFilter && multiple && value?.length) {
            matchesFilter = !value.some(x => {
                return filterSelectedItems ? x[itemId] === item[itemId] : false;
            });
        }

        return matchesFilter;
    });

    if (groupBy) {
        filterResults = filterGroupedItems(filterResults);
    }

    return filterResults;
}
